export default __webpack_public_path__ + "static/media/2219.d24d9320.png";